(ns common.schema.entity-type-names
  (:require [common.schema.entity-type-names-base :as entity-type-names-base]
            [common.schema.entity-type-registry :as entity-type-registry]))

(def base-entities
  "Re-exported from entity-type-names-base (which has zero dependency on the
  registry) so existing callers of entity-type-names/base-entities are
  unaffected - see that namespace's docstring for why the split exists."
  entity-type-names-base/base-entities)

(def entities
  (merge base-entities
         entity-type-registry/entity-type-names-for-backwards-compatibility))

;;TODO add other when needed:
(def plurals
  (->> entities
       (map (fn [[et meta]]
              [et {:field/translations (:plural meta)}]))
       (into {})))

(defn get-plural
  [et lang-kw]
  (-> (get entities et)
      :plural
      (get lang-kw)))

(defn get-name
  [et lang-kw]
  (-> (get entities et)
      :field/translations
      (get lang-kw)))

(defn entity-type-name
  "Resolve the display name / label for an entity type. Prefers runtime
  registrations; falls back to legacy `entity-type-names` mapping if present.
  If neither is available, returns the keyword name."
  [entity-type]
  (or (get entities entity-type)
      (name entity-type)))
